import { type LoaderFunctionArgs } from "@remix-run/node";
import { Loader2 } from "lucide-react";
import { useEffect } from "react";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "~/components/ui/card.tsx";
import { Link } from "~/components/ui/link.tsx";
import { requireAnonymousFront } from "~/utils/auth.server.ts";

export async function loader({ request }: LoaderFunctionArgs) {
  await requireAnonymousFront(request)

  return null
}

const redirectUrl = "https://edizioni.simone.it/il-mio-account/?redirect_to=bod.simone.it"

export default function SessioneScaduta() {

  useEffect(() => {
    setTimeout(() => {
      // redirect
      window.location.href = redirectUrl
    }, 2000)
  }, [])


  return (<div className="flex h-screen">
    <Card className="m-auto">
      <CardHeader>
        <CardTitle>Sessione Scaduta</CardTitle>
      </CardHeader>
      <CardContent>
        Sembra che la tua sessione sia scaduta.
        A breve verrai reindirizzato sul sito <Link to={redirectUrl}>edizioni.simone.it</Link> dove potrai accedere ad una nuova sessione...

      </CardContent>
      <CardFooter className="justify-center">
        <Loader2 className="animate-spin" />
      </CardFooter>

    </Card>
  </div>)
}